import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-globe',
  templateUrl: './globe.component.svg',
})
export class GlobeComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
